/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_EnabledInputs */

const en_team_manager_enabled = /** @type {(inputs: Team_Manager_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const fr_team_manager_enabled = /** @type {(inputs: Team_Manager_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activé`)
};

const de_team_manager_enabled = /** @type {(inputs: Team_Manager_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ermöglicht`)
};

const it_team_manager_enabled = /** @type {(inputs: Team_Manager_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilitato`)
};

const ru_team_manager_enabled = /** @type {(inputs: Team_Manager_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включено`)
};

const es_team_manager_enabled = /** @type {(inputs: Team_Manager_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activado`)
};

const zh_cn2_team_manager_enabled = /** @type {(inputs: Team_Manager_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已启用`)
};

const ja_team_manager_enabled = /** @type {(inputs: Team_Manager_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効`)
};

const hi_team_manager_enabled = /** @type {(inputs: Team_Manager_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय`)
};

const pt_pt2_team_manager_enabled = /** @type {(inputs: Team_Manager_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitado`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Team_Manager_EnabledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_enabled = /** @type {((inputs?: Team_Manager_EnabledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_EnabledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_enabled(inputs)
	if (locale === "de") return de_team_manager_enabled(inputs)
	if (locale === "it") return it_team_manager_enabled(inputs)
	if (locale === "ru") return ru_team_manager_enabled(inputs)
	if (locale === "es") return es_team_manager_enabled(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_enabled(inputs)
	if (locale === "ja") return ja_team_manager_enabled(inputs)
	if (locale === "hi") return hi_team_manager_enabled(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_enabled(inputs)
	return en_team_manager_enabled(inputs)
});